import { render, staticRenderFns } from "./block-splash.vue?vue&type=template&id=1fde4efe&scoped=true&"
import script from "./block-splash.vue?vue&type=script&lang=js&"
export * from "./block-splash.vue?vue&type=script&lang=js&"
import style0 from "./block-splash.vue?vue&type=style&index=0&id=1fde4efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde4efe",
  null
  
)

export default component.exports